import React, {useState, useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/application-breadcrumb.webp'
import callIcon from '../Images/call.png'
import whatsappIcon from '../Images/whatsapp.png'
import mailIcon from '../Images/mail.png'
import userIcon from '../Images/name.png'
import productIcon from '../Images/product.png'
import projectIcon from '../Images/project.png'
import areaIcon from '../Images/application.png'
import sizeIcon from '../Images/size.png'
import { products } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/ReCaptcha";

const ContactUs=()=>{
     useEffect(() => {
                document.title =
                  "Contact VigoFlex | Tile Adhesive Suppliers in Gujarat";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Get a quote or find a dealer near you. Contact VigoFlex for wholesale inquiries and expert technical support for your tiling projects in Gujarat."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://vigoflex.in/contact-us");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Contact VigoFlex | Tile Adhesive Suppliers in Gujarat"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Get a quote or find a dealer near you. Contact VigoFlex for wholesale inquiries and expert technical support for your tiling projects in Gujarat."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://vigoflex.in/contact-us");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://vigoflex.in/files/contact-us-img.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Contact VigoFlex | Tile Adhesive Suppliers in Gujarat"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Get a quote or find a dealer near you. Contact VigoFlex for wholesale inquiries and expert technical support for your tiling projects in Gujarat."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://vigoflex.in/files/contact-us-img.webp"
                );
              }
              }, [])


const generateToken = useRecaptcha();


const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};


const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6 }
  }
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};

const mapAnim = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  product: "",
  projectType: "",
  applicationArea: "",
  areaSize: "",
  message: ""
});
const [loading, setLoading] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name) return toast.error("Please enter your name");
  if (!formData.phone) return toast.error("Please enter phone number");
  if (!formData.email) return toast.error("Please enter email");
  if (!formData.product) return toast.error("Please select product");
  if (!formData.projectType) return toast.error("Please select project type");
  if (!formData.applicationArea) return toast.error("Please select application area");
  if (!formData.areaSize) return toast.error("Please enter area size");
  if (!formData.message) return toast.error("Please enter message");

  const phoneRegex = /^[0-9]{10}$/;

  if (!phoneRegex.test(formData.phone)) {
    return toast.error("Enter valid 10 digit phone number");
  }

  if (formData.areaSize <= 0) {
    return toast.error("Enter valid area size");
  }

  setLoading(true);

  // ✅ Generate reCAPTCHA token
  generateToken(async (token) => {
    try {

      // ✅ VERIFY RECAPTCHA
      const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Ldo3-UsAAAAAHQTL6lRmjEsXKU4VBqd6TEX6dIT"
      );

      recaptchaData.append("response", token);

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Recaptcha Score:", verifyRes.data.score);

      // ✅ BLOCK SPAM
      if (verifyRes.data.score <= 0.5) {
        toast.error("Spam detected. Please try again.");
        setLoading(false);
        return;
      }

      // ✅ EMAIL TEMPLATE
     const template = `
<div style="margin:0; padding:40px 0; background:#f4f7fb; font-family:Inter,Arial,sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center">

        <!-- MAIN CARD -->
        <table 
          width="620" 
          cellpadding="0" 
          cellspacing="0" 
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 10px 30px rgba(0,0,0,0.08);
          "
        >

          <!-- TOP HEADER -->
          <tr>
            <td
              style="
                background:linear-gradient(
                  135deg,
                  #EAF4FF 0%,
                  #D8EBFF 45%,
                  #BDDFFF 100%
                );
                padding:35px 30px;
                text-align:center;
              "
            >

              <!-- LOGO -->
              <img 
                src="https://vigoflex.in/files/logo.png"
                alt="VigoFlex Logo"
                style="
                  width:160px;
                  max-width:100%;
                  margin-bottom:18px;
                "
              />

              <!-- TITLE -->
              <h2
                style="
                  margin:0;
                  color:#1F60A0;
                  font-size:26px;
                  font-weight:700;
                  line-height:1.4;
                "
              >
                New Contact Form Inquiry
              </h2>

              <p
                style="
                  margin:10px 0 0;
                  color:#4E6E8E;
                  font-size:14px;
                  line-height:1.6;
                "
              >
                A new inquiry has been submitted through the VigoFlex website.
              </p>

            </td>
          </tr>

          <!-- BODY -->
          <tr>
            <td style="padding:35px 30px;">

              <!-- USER DETAILS -->
              <table 
                width="100%" 
                cellpadding="0" 
                cellspacing="0" 
                border="0"
                style="
                  border:1px solid #e6edf5;
                  border-radius:12px;
                  overflow:hidden;
                  margin-bottom:25px;
                "
              >

                <tr>
                  <td
                    style="
                      background:#C8E4FF40;
                      padding:14px 18px;
                      border-left:4px solid #CB2927;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#1F60A0;
                        font-size:18px;
                        font-weight:600;
                      "
                    >
                      User Details
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:20px 18px;">

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Name:</strong> ${formData.name}
                    </p>

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Phone:</strong> ${formData.phone}
                    </p>

                    <p style="margin:0; color:#383838; font-size:15px;">
                      <strong>Email:</strong> ${formData.email}
                    </p>

                  </td>
                </tr>

              </table>

              <!-- PROJECT DETAILS -->
              <table 
                width="100%" 
                cellpadding="0" 
                cellspacing="0" 
                border="0"
                style="
                  border:1px solid #e6edf5;
                  border-radius:12px;
                  overflow:hidden;
                  margin-bottom:25px;
                "
              >

                <tr>
                  <td
                    style="
                      background:#C8E4FF40;
                      padding:14px 18px;
                      border-left:4px solid #CB2927;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        color:#1F60A0;
                        font-size:18px;
                        font-weight:600;
                      "
                    >
                      Project Details
                    </h3>
                  </td>
                </tr>

                <tr>
                  <td style="padding:20px 18px;">

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Product:</strong> ${formData.product}
                    </p>

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Project Type:</strong> ${formData.projectType}
                    </p>

                    <p style="margin:0 0 12px; color:#383838; font-size:15px;">
                      <strong>Application Area:</strong> ${formData.applicationArea}
                    </p>

                    <p style="margin:0; color:#383838; font-size:15px;">
                      <strong>Area Size:</strong> ${formData.areaSize} Sq Ft
                    </p>

                  </td>
                </tr>

              </table>

              <!-- MESSAGE BOX -->
              <table 
                width="100%" 
                cellpadding="0" 
                cellspacing="0" 
                border="0"
                style="
                  border-radius:14px;
                  overflow:hidden;
                  background:linear-gradient(135deg,#1F60A0 0%,#0C1A47 100%);
                "
              >

                <tr>
                  <td style="padding:24px;">

                    <h3
                      style="
                        margin:0 0 18px;
                        color:#ffffff;
                        font-size:20px;
                        font-weight:700;
                      "
                    >
                      Customer Message
                    </h3>

                    <div
                      style="
                        background:rgba(255,255,255,0.08);
                        padding:18px;
                        border-radius:12px;
                      "
                    >

                      <p
                        style="
                          margin:0;
                          color:#ffffff;
                          font-size:15px;
                          line-height:1.8;
                        "
                      >
                        ${formData.message}
                      </p>

                    </div>

                  </td>
                </tr>

              </table>

            </td>
          </tr>

          <!-- FOOTER -->
          <tr>
            <td
              style="
                padding:22px;
                background:#f7f9fc;
                text-align:center;
                border-top:1px solid #e6edf5;
              "
            >

              <p
                style="
                  margin:0;
                  color:#7d8793;
                  font-size:13px;
                  line-height:1.6;
                "
              >
                © VigoFlex — High Performance Tile Adhesive Solutions
              </p>

            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</div>
`;

      // ✅ SEND MAIL
      const data = new FormData();

      data.append("title", "VigoFlex Website Contact Form");
      data.append("to_email", "info@vigoflex.in");
      data.append("cc", "arkayappsseo@gmail.com, sales@arkayapps.com");
      data.append("subject", "VigoFlex : New Contact Lead");
      data.append("template", template);

      await axios.post(
        "https://api.sendmail.adhyaynam.in/send-mail/two",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Query sent successfully 🚀");

      // ✅ RESET FORM
      setFormData({
        name: "",
        phone: "",
        email: "",
        product: "",
        projectType: "",
        applicationArea: "",
        areaSize: "",
        message: "",
      });

    } catch (error) {
      console.log(error.response?.data || error);

      toast.error("Verification failed. Please try again!");
    } finally {
      setLoading(false);
    }
  });
};

    return(
        <>
         {/**BREADCRUMB */}
        <Breadcrumb
        title="Contact us"
        bgImage={bgImg}
      />

      {/**CONTACT FORM */}
     <motion.section
  className="contact-section"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  <ToastContainer position="top-right" autoClose={3000} />
        <div className="container contact-wrapper">

          {/* LEFT */}
<motion.div className="contact-left" variants={container}>
           <motion.h3 variants={fadeUp} className="section-subheading">Contact us</motion.h3>
            <motion.h2 variants={fadeUp} className="section-heading">
  Get in Touch with VigoFlex
</motion.h2>

            <motion.p variants={fadeUp} className="section-text">
 Have a project requirement or need help choosing the right adhesive? Our team is here to assist you.
</motion.p>

            {/* ITEMS */}
            <motion.div variants={fadeUp} className="contact-item-form">
              <div className="icon-box">
                <img src={callIcon} alt="Call Icon | VigoFlex" />
              </div>
              <div>
  <h4 className="card-heading">Call Us</h4>
  <p className="section-text">Speak directly with our team</p>

  <a href="tel:+917016591400" className="phone-link">
    +91 7016591400
  </a>
</div>
            </motion.div>

           <motion.div variants={fadeUp} className="contact-item-form">
              <div className="icon-box">
                <img src={whatsappIcon} alt="Whatsapp Icon | VigoFlex" />
              </div>
            <a
  href="https://wa.me/917016591400?text=Can%20I%20get%20more%20info%20about%20your%20products"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-link"
>
  <div>
    <h4 className="card-heading">WhatsApp</h4>
    <p className="section-text">Get quick responses instantly</p>
    <span>Click here to chat</span>
  </div>
</a>
            </motion.div>

            <motion.div variants={fadeUp} className="contact-item-form">
              <div className="icon-box">
                <img src={mailIcon} alt="Mail Icon | VigoFlex" />
              </div>
           <a href="mailto:info@vigoflex.in" className="email-link">
  <div>
    <h4 className="card-heading">Email Us</h4>
    <p className="section-text">Send your requirements</p>
    <span>info@vigoflex.in</span>
  </div>
</a>
            </motion.div>

            {/* ADDRESS */}
           <motion.div variants={fadeUp} className="contact-address">
              <h4 className="section-subheading">Reach us at</h4>
              <h3 className="section-heading">Our office address</h3>

              <p className="section-text">
               Rev. Sr. No. 225/1,<br />
Bhuj Mundra Highway Road,<br />
At Post: Gajod,<br />
Tal: Bhuj, Dist. Kutch, Gujarat – 370430, India<br />
              </p>
            </motion.div>
          </motion.div>

          {/* RIGHT FORM */}
         <motion.div
  className="contact-form-box"
  variants={fadeRight}
>
            <motion.div className="form-header" variants={fadeUp}>
              <div className="icon-box-form">
                <img src={whatsappIcon} alt="Message Icon | VigoFlex" />
              </div>
              <div>
                <h4 className="card-heading">Send us a message</h4>
                <p className="section-text">Fill in the details and we’ll get back to you shortly</p>
              </div>
            </motion.div>

            <motion.form
  className="contact-form"
  variants={container}
  onSubmit={handleSubmit}
>

              {/* NAME */}
              <motion.div variants={fadeUp} className="form-group full">
                <label>Full Name <span>*</span></label>
                <div className="input-box">
                  <span className="input-icon"><img src={userIcon} alt="User Icon | VigoFlex" /></span>
                  <input type="text" placeholder="Enter your full name" 
                  name="name"
                  value={formData.name}
  onChange={handleChange}
/>
                </div>
              </motion.div>

              {/* PHONE + EMAIL */}
              <motion.div variants={fadeUp} className="form-row">
                <div className="form-group">
                  <label>Phone Number <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={callIcon} alt="Call Icon | VigoFlex" /></span>
                    <input type="text" placeholder="Enter phone number" 
                    name="phone"
                    value={formData.phone}
  onChange={handleChange}
/>
                  </div>
                </div>

                <div className="form-group">
                  <label>Email Address <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={mailIcon} alt="Mail Icon | VigoFlex" /></span>
                    <input type="email" placeholder="Enter email address"
                    name="email"
                    value={formData.email}
  onChange={handleChange}
 />
                  </div>
                </div>
              </motion.div>

              {/* PRODUCT + PROJECT */}
              <motion.div variants={fadeUp} className="form-row">
                <div className="form-group">
                  <label>Product Interested in <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={productIcon} alt="Bag Icon | VigoFlex" /></span>
                    <select
                    name="product"
                    value={formData.product}
  onChange={handleChange}
>
                      <option value="">Select a product</option>
                      {products.map((item, i) => (
  <option key={i} value={item.title}>
    {item.title}
  </option>
))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Project Type <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={projectIcon} alt="Project type Icon | VigoFlex" /></span>
                    <select
                    name="projectType"
                    value={formData.projectType}
  onChange={handleChange}
>
                      <option value="">Select project type</option>
<option value="residential_new">Residential – New Construction</option>
<option value="residential_renovation">Residential – Renovation</option>
<option value="commercial">Commercial Project</option>
<option value="industrial">Industrial Project</option>
<option value="builder_developer">Builder / Developer</option>
<option value="contractor">Contractor / Applicator</option>
<option value="dealer">Dealer / Distributor Inquiry</option>
<option value="architect_designer">Architect / Interior Designer</option>
<option value="other">Other</option>
                    </select>
                  </div>
                </div>
              </motion.div>

              {/* AREA + SIZE */}
              <motion.div variants={fadeUp} className="form-row">
                <div className="form-group">
                  <label>Application Area <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={areaIcon} alt="Application Icon | VigoFlex" /></span>
                    <select
                    name="applicationArea"
                    value={formData.applicationArea}
  onChange={handleChange}
>
                      <option value="">Select application area</option>
                      <option>Interior</option>
                      <option>Exterior</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Approx Area Size (Sq. Ft.) <span>*</span></label>
                  <div className="input-box">
                    <span className="input-icon"><img src={sizeIcon} alt="Area Icon | VigoFlex" /></span>
                    <input type="number" placeholder="Enter area size" 
                    name="areaSize"
                    value={formData.areaSize}
  onChange={handleChange}
/>
                  </div>
                </div>
              </motion.div>

              {/* MESSAGE */}
              
<motion.div variants={fadeUp} className="form-group full">
                <label>Message / Requirements <span>*</span></label>
                <div className="input-box textarea-box">
                  <span className="input-icon"><img src={whatsappIcon} alt="Message Icon | VigoFlex" /></span>
                  <textarea placeholder="Tell us more about your requirements"
                  name="message"
                  value={formData.message}
  onChange={handleChange}
></textarea>
                </div>
              </motion.div>

              <motion.button
  variants={fadeUp}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  className="btn btn-primary"
  disabled={loading}
>
  {loading ? "Sending..." : "Send Query"}
</motion.button>

            </motion.form>
          </motion.div>

        </div>
      </motion.section>

      {/**MAP */}
      <motion.section
      className="map-section"
      variants={mapAnim}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      <div className="map-wrapper">
        <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.322175981279!2d69.60572291128192!3d23.0486471790686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3951278099340013%3A0xa6340accc62de6d3!2sVigoFlex!5e0!3m2!1sen!2sin!4v1779076898665!5m2!1sen!2sin" 
          title="VigoFlex Location"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </div>
    </motion.section>
        </>
    )
}
export default ContactUs;